module.exports = __webpack_public_path__ + "img/plane_top.0b248683.svg";